import { AppConfigContext } from '@App/AppConfigContext';
import React, { useContext } from 'react';

interface Props {
  featureName: string;
  forceActive?: boolean;
  renderIfDisabled?: boolean;
}

const Feature: React.FC<Props> = ({ renderIfDisabled, featureName, children, forceActive }) => {
  const { features } = useContext(AppConfigContext);

  if (features === undefined && !forceActive) {
    return <></>;
  }

  const currentFeature = features[featureName];

  const featureIsEnabled = (currentFeature !== undefined && currentFeature === true) || forceActive === true;
  // featureIsEnabled and renderIfDisabled are completely mutually exclusive
  if (featureIsEnabled && !renderIfDisabled) {
    return <>{children}</>;
  } else if (!featureIsEnabled && renderIfDisabled) {
    return <>{children}</>;
  }

  return <></>;
};

export { Feature };
